/**
 * 全局轮询
 */

import * as Ids from '@utils/ids';

import setParamsPoller from './poller/setParams';
import reportPcInfoPoller from './poller/reportPcInfo';
import autoAcceptPoiListPoller from './poller/autoAcceptPoiList';
import preOrderCountPoller from './poller/preOrderCount';
import reportPushToken from './poller/reportPushToken';
import timeoutCancelOrderPoller from './poller/timeoutCancelOrder';
import reportOperationStatusPoller from './poller/reportOperationStatus';
import businessStatusPoller from './poller/businessStatus';
import feCommonReport from './poller/feCommonReport';
import privacyPhoneNotificationPoller from './poller/privacyPhoneNotification';
import compensateProtocolPoller from './poller/compensateProtocol';
import feVersionPoller from './poller/feVersion';
import unReadNotificationCount from './poller/unReadNotificationCount';
import deliverDelayNotification from './poller/deliverDelayNotification';
import demotionNotification from './poller/demotionNotification';
import businessMessagePoller from './poller/businessMessage';

const init = () => {
    /** set化参数 */
    setParamsPoller.init();
    /** 自动接单门店列表 */
    autoAcceptPoiListPoller.init();
    /** 临近送达时间预订单 */
    preOrderCountPoller.init();
    /** 超时取消订单 */
    timeoutCancelOrderPoller.init();

    if (Ids.getWmPoiId() !== '-1') {
        // 单店状态下轮询门店营业状态
        businessStatusPoller.init();
        // 异常天气延长配送通知
        deliverDelayNotification.init();
        // 降级黄条
        demotionNotification.init();
    }

    unReadNotificationCount.init();
    feVersionPoller.init();
    reportPcInfoPoller.init();
    reportOperationStatusPoller.init();
    reportPushToken.init();
    feCommonReport.init();
    privacyPhoneNotificationPoller.init();
    compensateProtocolPoller.init();
    businessMessagePoller.init();
};

export default init;
